<template>
  <div class="j-week--content">
    <div class="journal--bar-container">
      <div class="journal--bar-dates">
        <div class="left" @click="prevWeek">
          <f-awesome icon="arrow-left"></f-awesome>
        </div>
        <div class="date">
          <b>{{ weekString }}</b>
        </div>
        <div class="right" @click="nextWeek">
          <f-awesome icon="arrow-right"></f-awesome>
        </div>
      </div>
      <div class="journal--bar-staff">

      </div>
      <div class="journal--bar-actions">
        <mode-journal
          @selectJournalMode="selectJournalMode"
          :modeList="modeJournalList"
          :modeActive="modeJournalActive"
        ></mode-journal>
      </div>
    </div>
    <div class="j-week--labels-container">
      <div class="j-week--labels-slide mrg-t-10 text-center  text-underline cursor-pointer">
        <div v-if="!openEnroll" @click="openEnrollToggle"><f-awesome icon="caret-down"></f-awesome> Развернуть все</div>
        <div v-if="openEnroll" @click="openEnrollToggle"><f-awesome icon="caret-up"></f-awesome> Свернуть все</div>
      </div>
      <div class="j-week--labels-overflow">
          <enroll-labels-week
            :data="calendar"
            :show="showLabels"
            :staff="staff"
            @slideEnroll="slideEnroll"
          ></enroll-labels-week>
      </div>
    </div>
  </div>
</template>

<script>
import Formatter from "../../libraries/Formatter";
import journalRepository from "../../../repositories/journal";

const formatter = new Formatter();

import ModeJournal from "./ModeJournal";
import EnrollLabels from "@/components/panel/journal/EnrollLabels";
import EnrollLabelsWeek from "./EnrollLabelsWeek.vue";
import Hints from '../../Hints.vue';
import websocketEventBus from "../../../eventBus/websocketEventBus";
export default {
  name: "JournalWeek",
  components: { EnrollLabels, ModeJournal, EnrollLabelsWeek, Hints },
  data() {
    return {
      staffModel: "",
      nowDate: new Date(),
      weekdayName: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
      weekdayNumber: [6, 0, 1, 2, 3, 4, 5],
      dateFrom: null,
      dateTo: null,
      calendar: [],
      showLabels: false,
      intervalProgress: false,
      openEnroll: false, // Раскрытие ярлыков с записями
    };
  },
  props: {
    modeJournalList: Array,
    modeJournalActive: String,
    staff: Array,
  },
  watch: {
    staff: function(val) {
      this.staffModel = val[0].id;
    },
    staffModel: function() {
      this.renderWeek();
    },
    showLabels: function(val){
      if (val) {
        this.setProgress();
        this.intervalProgress = setInterval(this.setProgress, 2000);
      } else {
        clearInterval(this.intervalProgress);
      }
    }
  },
  computed: {
    weekString() {
      let result = "";
      if (this.dateFrom) {
        let dateFrom = formatter.phpDateToJSObject(this.dateFrom);
        let dateTo = formatter.phpDateToJSObject(this.dateTo);
        let monthFrom = formatter.getMonthNameShort(dateFrom.getMonth());
        let monthTo = formatter.getMonthNameShort(dateTo.getMonth());
        result = `${dateFrom.getDate()} ${monthFrom} -
          ${dateTo.getDate()} ${monthTo}`;
      }
      return result;
    },
    staff_avatar() {
      let result = null;
      if (this.staffModel !== null) {
        for (let key in this.staff) {
          if (+this.staff[key].id === +this.staffModel) {
            result = this.staff[key].avatar;
          }
        }
      }
      return result;
    }
  },
  methods: {
    setProgress() {
      let nowDate = new Date();
      let minutes = formatter.hourMinuteToMinute(
        nowDate.getHours(),
        nowDate.getMinutes()
      );

      for(let cal in this.calendar){
        if(formatter.isIdenticalDates(this.calendar[cal].date, formatter.jsObjectToPhp(nowDate))){
          for(let staff in this.calendar[cal].labels){
            if(this.calendar[cal].labels[staff].result == 'ok'){
              for(let sch in this.calendar[cal].labels[staff].response){
                if (
                  minutes >= +this.calendar[cal].labels[staff].response[sch].time_from &&
                  minutes < +this.calendar[cal].labels[staff].response[sch].time_to
                ) {
                  this.$set(this.calendar[cal].labels[staff].response[sch], 'progress', true);
                }else{
                  this.$set(this.calendar[cal].labels[staff].response[sch], 'progress', false);
                }
              }
            }
          }
        }
      }
      this.calendar = Array.from(this.calendar);
    },
    prevWeek() {
      this.nowDate.setDate(this.nowDate.getDate() - 7);
      this.renderWeek();
    },
    nextWeek() {
      this.nowDate.setDate(this.nowDate.getDate() + 7);
      this.renderWeek();
    },
    selectJournalMode(val) {
      this.$emit("selectJournalMode", val);
    },
    renderWeek() {
      let nowDay = this.weekdayNumber[this.nowDate.getDay()];
      this.nowDate.setDate(this.nowDate.getDate() - nowDay);

      let date = new Date(
        this.nowDate.getFullYear(),
        this.nowDate.getMonth(),
        this.nowDate.getDate()
      );
      let today = new Date();
      this.dateFrom = formatter.dateToPhpFormat(date);

      this.calendar = [];
      for (let i = 0; i <= 6; i++) {
        let dayObj = {};
        dayObj.date = formatter.jsObjectToPhp(date);
        dayObj.isToday = formatter.isIdenticalDates(formatter.jsObjectToPhp(date), formatter.jsObjectToPhp(today));
        dayObj.weekday = this.weekdayName[date.getDay()];
        dayObj.labels = {};
        this.calendar.push(dayObj);
        if (i === 6) {
          this.dateTo = formatter.dateToPhpFormat(date);
        }
        date.setDate(date.getDate() + 1);
      }
      this.calendar = this.calendar.reverse();
      this.getLabels();
    },
    slideEnroll(id) {
      for(let cal in this.calendar){
        for(let staff in this.calendar[cal].labels){
          if(this.calendar[cal].labels[staff].result == 'ok'){
            for(let sch in this.calendar[cal].labels[staff].response){
              if(+this.calendar[cal].labels[staff].response[sch].id === +id){
                this.$set(this.calendar[cal].labels[staff].response[sch], 'show_more', !this.calendar[cal].labels[staff].response[sch].show_more);
              }
            }
          }
        }
      }
      this.calendar = Array.from(this.calendar);
    },
    openEnrollAction(val){
      for(let cal in this.calendar){
        for(let staff in this.calendar[cal].labels){
          if(this.calendar[cal].labels[staff].result == 'ok'){
            for(let sch in this.calendar[cal].labels[staff].response){
              this.$set(this.calendar[cal].labels[staff].response[sch], 'show_more', val);
            }
          }
        }
      }
      this.calendar = Array.from(this.calendar);
    },
    openEnrollInit(){
      let storage = localStorage.getItem("openEnroll");
      if(storage === null){
        localStorage.setItem("openEnroll", false);
      }else{
        this.openEnroll = formatter.boolStringToType(storage);
      }
    },
    openEnrollToggle(){
      let storage = localStorage.getItem("openEnroll");
      if(storage === null){
        // На всякий случай
        localStorage.setItem("openEnroll", false);
      }else{
        this.openEnroll = !this.openEnroll;
        localStorage.setItem("openEnroll", this.openEnroll);
        this.openEnrollAction(this.openEnroll);
      }
    },
    getLabels() {
      this.showLabels = false;
      //this.$store.dispatch("startPreloader");
      journalRepository.getForWeekdayMode({
        'dateFrom': this.dateFrom,
        'dateTo': this.dateTo
      }).then(resp => {
        this.lastUpdate = new Date();
        for (let key in resp.data) {
          for (let cal in this.calendar) {
            if (key === this.calendar[cal].date) {
              for(let keyStaff in resp.data[key]){
                this.$set(this.calendar[cal]['labels'], keyStaff, resp.data[key][keyStaff]);
              }
            }
          }
        }
        for(let cal in this.calendar){
          for(let staff in this.calendar[cal].labels){
            if(this.calendar[cal].labels[staff].result == 'ok'){
              for(let sch in this.calendar[cal].labels[staff].response){
                this.calendar[cal].labels[staff].response[sch].show_more = this.openEnroll;
                this.calendar[cal].labels[staff].response[sch].progress = false;
              }
            }
          }
        }

        this.showLabels = true;
        //this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        //this.$store.dispatch("stopPreloader");
      });
    },
    websocketSaveEnrollObserve() {
      this.getLabels();
    },
    websocketDeleteEnrollObserve(data) {
      if (formatter.isDateInRange(this.dateFrom, this.dateTo, data.data.date)){
        this.getLabels();
      }
    },
  },
  created() {
    if (this.staff.length) {
      this.staffModel = this.staff[0].id;
    }
    this.openEnrollInit();
    websocketEventBus.subscribeToSaveEnroll(this.websocketSaveEnrollObserve);
    websocketEventBus.subscribeToDeleteEnroll(this.websocketDeleteEnrollObserve);
  },
  beforeDestroy() {
    websocketEventBus.unsubscribeFromSaveEnroll(this.websocketSaveEnrollObserve);
    websocketEventBus.unsubscribeFromDeleteEnroll(this.websocketDeleteEnrollObserve);
  },
};
</script>

<style scoped lang="less">
.j-week--labels-container {
  .j-week--labels-last-update{
    margin-top: 25px;

    .text{
      font-size: 12px;
      color: gray;
    }
    .hint{
      margin-left: 5px;
    }
  }
  .j-week--labels-overflow {
    overflow: auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    flex-direction: row;
    margin-top: 5px;

    .item {
      min-width: 230px;
      width: 350px;
      margin-right: 8px;
    }
  }
}
</style>
